import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { IoIosAdd } from 'react-icons/io'
import TrashButton from '../../components/TrashButton'
import styles from './styles.module.scss'
import Button from '../../components/Button'
import Loader from '../../components/Loader'
import Table from '../../components/Table'
import Title from '../../components/Title'
import Empty from '../../components/Empty'
import Confirmation from '../../components/Confirmation/Confirmation'
import Modal from './Modal'
import { deleteSchoolYear, getSchoolYearsList } from '../../actions/schoolYears'
export default function SchoolYears() {
  const dispatch = useDispatch()
  const { list, loading } = useSelector(state => state.school_years)
  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false)
  const [sortField, setSortField] = useState('name')
  const [sortAsc, setSortAsc] = useState(true)

  useEffect(() => {
    dispatch(getSchoolYearsList())
  }, [dispatch])

  const handleSort = (field) => {
    if (sortField === field) setSortAsc(v => !v)
    else { setSortField(field); setSortAsc(true) }
  }

  const sortedList = useMemo(() => {
    if (!list) return []
    return [...list].sort((a, b) => {
      const aVal = a[sortField] ?? ''
      const bVal = b[sortField] ?? ''
      if (typeof aVal === 'number' && typeof bVal === 'number')
        return sortAsc ? aVal - bVal : bVal - aVal
      return sortAsc
        ? String(aVal).localeCompare(String(bVal), 'ru')
        : String(bVal).localeCompare(String(aVal), 'ru')
    })
  }, [list, sortField, sortAsc])

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const acceptConfirmation = () => {
    dispatch(deleteSchoolYear(confirmation.id))
    setConfirmation(false)
  }

  const rejectConfirmation = () => {
    setConfirmation(false)
  }

  const handleDeleteClick = (e, xp_key, name) => {
    e.stopPropagation()
    setConfirmation({ id: xp_key, name })
  }

  const renderRow = (data) => {
    const { name, xp_key, begdate, enddate } = data
    return (
      <tr key={xp_key} onClick={openModal(data)}>
        <td>{name}</td>
        <td>{moment(begdate).format('DD.MM.YYYY')}</td>
        <td>{moment(enddate).format('DD.MM.YYYY')}</td>
        <td>
          <TrashButton onClick={(e) => handleDeleteClick(e, xp_key, name)} />
        </td>
      </tr>
    )
  }

  const renderContent = () => {
    if (loading) {
      return (
        <div className={styles.loader}>
          <Loader />
        </div>
      )
    }

    if (!list?.length) {
      return <Empty />
    }

    return (
      <Table className={styles.table}>
        <thead>
          <tr>
            <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>Название</th>
            <th onClick={() => handleSort('begdate')} style={{ cursor: 'pointer' }}>Дата начала</th>
            <th onClick={() => handleSort('enddate')} style={{ cursor: 'pointer' }}>Дата конца</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {sortedList?.map(renderRow)}
        </tbody>
      </Table>
    )
  }

  return (
    <div className={styles.wrapper}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить "${confirmation.name}"?`}
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      <Modal closeModal={closeModal} data={selectedItem} width="500px" height="450px" />
      <header className={styles.header}>
        <Title title="Учебные года" />
      </header>
      <div className={styles.content}>
        {renderContent()}
        <div className={styles.actions}>
          <Button className={styles.addButton} onClick={openModal()}>
            <IoIosAdd size={30} />
            Добавить учебный год
          </Button>
          <span className={styles.counter}>Всего записей: {list?.length || 0}</span>
        </div>
      </div>
    </div>
  )
}
